import { useState } from "react";
import { Button } from "antd";
import { AdminToolCommonModal } from "./AdminToolCommonModal";
const DeleteButton = (props) => {
    const { dataType, Delete, record, handleDelete } = props;
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);

    const openDeleteModal = () => {
      setDeleteModalVisible(true);
    };

    const closeDeleteModal = () => {
      setDeleteModalVisible(false);
    };
    const DeleteModalBody = () => {
      return (
        <>
          <div>
            <div className="ms-2">
              <h5 className="hs-color-dark-blue">
                {Delete} {dataType}
              </h5>
              <div className="hs-color-dark-blue">
                Are you sure you want to {Delete} this {dataType}?
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-end m-2">
            <Button className="mt-2 hs-fs-16 w-100 h-45 hs-button-v-cancel" onClick={closeDeleteModal}>
              Cancel
            </Button>
            <Button
              className="hs-fs-16 ms-3 mt-2 row-reverse d-inline-block w-100 h-45 confirmDeleteBtn"
              onClick={() => handleDelete(record, dataType)}
            >
              {Delete}
            </Button>
          </div>
        </>
      );
    };
    return (
      <>
        <AdminToolCommonModal
          width={350}
          body={<DeleteModalBody />}
          open={deleteModalVisible}
          modalIcon={<div className="actionIconsSprite hs-delete-icon" />}
        />
        <div onClick={openDeleteModal} className={"d-flex align-items-center w-100 cursor-pointer"}>
          <div className="actionIconsSprite delete-icon-admin-tool" />
          <span className="hs-fs-12">
            {Delete} {dataType}
          </span>
        </div>
      </>
    );
}

export default DeleteButton;